import { useInjection } from "@linkfluence/core/di";
import { Platform } from "@linkfluence/models/platform";
import { useInfiniteQuery } from "@tanstack/react-query";
import { CorporaSource, CorporaSourcePayload } from "@radarly/models/corpora";
import { CorporaRepo, CorporaRepositoryUID } from "../repositories/CorporaRepo";

const formatData = (pages): CorporaSource[] => {
  return pages.reduce((sources, page) => {
    return [...sources, ...page.data];
  }, []);
};
export function useCorporaPlatformSources(
  project: number,
  corpusId: number,
  platform: Platform,
  sourcesPerPage: number = 36
) {
  const repository = useInjection<CorporaRepo>(CorporaRepositoryUID);
  const getPayload = (page = 0): CorporaSourcePayload => ({
    count: sourcesPerPage,
    offset: sourcesPerPage * page,
    orderBy: "name",
    search: "",
    sort: "asc",
  });
  const { data, isLoading, isFetchingNextPage, fetchNextPage, isError } =
    useInfiniteQuery(
      ["/corpora-platform-sources/get", { project, corpusId, platform }],
      ({ pageParam = 1 }) => {
        return repository.getCorporaPlatformSources(
          project,
          corpusId,
          platform,
          getPayload(pageParam - 1)
        );
      },
      { getNextPageParam: (_, pages) => pages.length + 1 }
    );
  return {
    sources: data ? formatData(data.pages) : [],
    loading: isLoading || isFetchingNextPage,
    error: isError,
    loadMore: () => fetchNextPage(),
  };
}
